























import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";

import { api } from "@/store/modules/data";

import PieChart from "@/components/charts/PieChart";
import "chartjs-plugin-colorschemes";
import { calculateMeasureTypesProportionData } from "@/utils/DataTransformations";

@Component({
  components: {
    PieChart
  }
})
export default class FindingTypesView extends Vue {
  chartJSOptions = {
    maintainAspectRatio: false,
    plugins: {
      colorschemes: {
        scheme: "brewer.SetOne9"
      }
    }
  };

  pieChartOptions = {
    legend: {
      position: "top"
    }
  };

  @Action(api.actions.loadData, { namespace: api.namespace })
  loadData!: () => Promise<void>;

  @Getter(api.getters.getRawData, {
    namespace: api.namespace
  })
  rawData!: any;

  get measureTypesPoportionData() {
    return calculateMeasureTypesProportionData(this.rawData);
  }

  mounted() {
    this.loadData();
  }
}
